<app-input [fc]="fc" (inputBlur)="onBlur()" [icon]="ICONS.CLOCK" [placeholder]="'time_input_placeholder' | t">
